import React, { useEffect, useState } from 'react'
import Basic from '../../container/layouts/Basic'
import { extractParams } from '../../utils/paramsURLUtils'
import IframeV1 from '../Admin/IFrame/Iframe'


export default function ResetPwdPage() {
  const [urlParams, setUrlParams] = useState({})
  
  useEffect(() => {
    // Récupérer les paramètres de l'URL directement depuis window.location
    const params = extractParams(window.location.search)
    setUrlParams(params)
    
    // Log pour debug
    console.log('Paramètres URL récupérés:', params)
    console.log('Query:', params.query)
    console.log('IdRequest:', params.requestId)
  }, [])
  
  return (
    <Basic page="resetpwd" noBanner>
      <IframeV1
        url={`/resetpwd`}
        title="ResetPwd"
        otherParam={`&requestId=${urlParams.requestId}`}
      />
    </Basic>
  )
}

export const ResetPwdRequestPage = () => {
  return (
    <Basic page="resetpwd" noBanner>
      <IframeV1
        url={`/resetpwd/request`}
        title="ResetPwd"
      />
    </Basic>
  )
}
